import styled from "@emotion/styled";
export const ItemRoot = styled.div`
  margin-top: 0.5rem;
  padding: 0.5rem;
`;
export const ItemContent = styled.div`
  display: flex;
  align-items: center;
`;
export const ItemPickerHeader = styled.div`
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
`;
export const ItemPickerList = styled.div`
  overflow-y: auto;
`;
